class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);


function applyDiscountCode() {
  // const sections = ['cart-drawer', 'cart-icon-bubble'];
   const sections = ['cart-drawer', 'main-cart-items', 'cart-icon-bubble'];

  // 1. Handle each .discount-component separately
  document.querySelectorAll('.discount-component').forEach(discountComponent => {
    const input = discountComponent.querySelector('.cart-discount__input');
    const applyBtn = discountComponent.querySelector('.applyDiscount');
    const errorEl = discountComponent.querySelector('.coupen-error');
    const appliedCoupon = discountComponent.querySelector('.applied-coupon-wrapper');
    // console.log("applies coupen",appliedCoupon);
    const removeBtn = discountComponent.querySelector('.remove-btn');

    //on load and on change fetch
    fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      // console.log("Cart",cart);
      const appliedDiscount = (cart.discount_codes?.[0]?.applicable)? cart.discount_codes[0].code: null;
      const errorEl = discountComponent.querySelector(".coupen-error");
      if(appliedDiscount){
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.add("hidden");
        }
        if(appliedDiscount){
          const appliedCoupon = discountComponent.querySelector(".applied-coupon-wrapper");
          appliedCoupon.classList.remove('hidden');
          appliedCoupon.querySelector(".cart-coupon").textContent = appliedDiscount;
        }
      }
    });
    //on load and on change fetch

    if (applyBtn) {
      applyBtn.addEventListener('click', () => {
        const discountCode = input.value.trim();

        if (!discountCode) {
          if (errorEl) {
            errorEl.classList.remove('hidden');
            errorEl.textContent = 'Coupon does not exist!';
          }
          return;
        }

        // Hide previous error
        if (errorEl) {
          errorEl.classList.add('hidden');
          errorEl.textContent = '';
        }
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            discount: discountCode,
            sections: sections
          })
        })
        .then(res => res.json())
        .then(response => {
          console.log("Response",response);
          // // ✅ Only update custom-cart-items and other known sections
          // if (response.sections) {
          //   for (const [sectionId, html] of Object.entries(response.sections)) {
          //     const container = document.getElementById(sectionId);
          //     if (container) {
          //       container.innerHTML = html;
          //     }
          //   }
          // }
    
          // ✅ Trigger cart drawer open if present
          const cartDrawer = document.querySelector('cart-drawer');
          const cartBtn = document.querySelector('#cart-icon-bubble');
    
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(response);
          }
    
          cartBtn?.dispatchEvent(new Event("click", { bubbles: true }));
    
          // ✅ Dispatch custom refresh event
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: response
          }));
    
          // ✅ Handle coupon result display
          const matchedCoupon = response.discount_codes?.find(codeObj =>
            codeObj.code.toUpperCase() === discountCode.toUpperCase()
          );
    
          setTimeout(() => {
            if (matchedCoupon && matchedCoupon.applicable === false) {
              if (errorEl) {
                errorEl.textContent = `Coupon "${matchedCoupon.code}" does not exist!`;
                errorEl.classList.remove("hidden");
              }
            } else {
              if (appliedCoupon) {
                appliedCoupon.classList.remove("hidden");
                appliedCoupon.querySelector(".cart-coupon").textContent =
                  matchedCoupon?.code || discountCode;
              }
            }
          }, 200);
        })
        .catch(err => {
          console.error("Discount apply error:", err);
        });
      });
    }

    // Remove discount
    if (removeBtn) {
      removeBtn.addEventListener('click', () => {
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            discount: '',
            sections: sections
          })
        })
        .then(res => res.json())
        .then(response => {
          if (appliedCoupon) {
            appliedCoupon.classList.add('hidden');
          }

          const cartDrawer = document.querySelector('cart-drawer');
          const cartbtn = document.querySelector('#cart-icon-bubble');
          cartDrawer?.classList.remove('is-empty');
          cartDrawer?.renderContents(response);
          cartbtn?.dispatchEvent(new Event("click", { bubbles: true }));
        });
      });
    }
  });

  // 2. Handle popup logic (shared global popup)
  const popup = document.querySelector('.offercode-popup');
  const overlay = document.querySelector('.offercode-overlay');
  const closeIcon = document.querySelector('.popup-close-icon');

  // Attach event to all "View Discount" buttons
  document.querySelectorAll('.view-discount-offer-button').forEach(offerButton => {
    offerButton.addEventListener('click', () => {
      popup?.classList.add('active');
      overlay?.classList.add('active');
    });
  });

  const closePopup = () => {
    popup?.classList.remove('active');
    overlay?.classList.remove('active');
  };

  closeIcon?.addEventListener('click', closePopup);
  overlay?.addEventListener('click', closePopup);

  // 3. Handle coupon buttons inside popup
  if (popup) {
    popup.querySelectorAll(".apply-button").forEach(couponBtn => {
      couponBtn.addEventListener('click', () => {
        const discountCode = couponBtn.closest(".coupon-row")?.getAttribute("data-couponcode");
        if (!discountCode) return;

        // Apply using first component (or you can enhance this to apply to all)
        const discountComponent = document.querySelector('.discount-component');
        if (discountComponent) {
          const input = discountComponent.querySelector('.cart-discount__input');
          if (input) input.value = discountCode;
          const applyBtn = discountComponent.querySelector('.applyDiscount');
          applyBtn?.click(); // trigger existing apply
        }

        closePopup();
      });
    });
  }
}

// function applyDiscountCode(){
  
//   // show discount codes Popup
//     const offerButton = document.querySelector('.view-discount-offer-button');
//     const popup = document.querySelector('.offercode-popup');
//     const overlay = document.querySelector('.offercode-overlay');
//     const closeIcon = document.querySelector('.popup-close-icon');
    
//     if (offerButton && popup && overlay) {
//       offerButton.addEventListener('click', function () {
//         popup.classList.add('active');
//         overlay.classList.add('active');
//       });
//     }
    
//     function closePopup() {
//       popup?.classList.remove('active');
//       overlay?.classList.remove('active');
//     }
    
//     closeIcon?.addEventListener('click', closePopup);
//     overlay?.addEventListener('click', closePopup);
//  // show discount codes Popup
  
//   function discountInCart(discountCode){
//     let sections = ['cart-drawer', 'cart-icon-bubble'];
//      fetch("/cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "Accept": "application/json"
//       },
//       body: JSON.stringify({
//       "discount":discountCode,
//         sections: sections
//       })
//     })
//     .then(res => res.json())
//     .then((response) => {
     
//       const cartbtn = document.querySelector('#cart-icon-bubble');
//       const cartDrawer = document.querySelector('cart-drawer');
      
//       cartDrawer.classList.remove('is-empty');          
//       cartDrawer.renderContents(response);
//       cartbtn.dispatchEvent(new Event("click", { bubbles: true }));
  
//       const matchedCoupon = response.discount_codes.find(codeObj => codeObj.code.toUpperCase() === discountCode.toUpperCase());
//       const errorEl = document.querySelector(".discount-component .coupen-error");
//       if (matchedCoupon && matchedCoupon.applicable === false) {
//         console.log("response.discount_codes.applicable", matchedCoupon.applicable);
    
//         if (errorEl) {
//           errorEl.textContent = `Coupon ${matchedCoupon.code} does not exist!`;
//           errorEl.classList.remove("hidden");
//         }
//       }else{
//         if (errorEl) {
//           errorEl.textContent = '';
//           errorEl.classList.add("hidden");
//         }
//         const appliedCoupon = document.querySelector(".applied-coupon-wrapper");
//         appliedCoupon.classList.remove('hidden');
//         appliedCoupon.querySelector(".cart-coupon").textContent = matchedCoupon.code;
//       }
//     })
//     .catch(error => {
//       console.error("Error updating cart:", error);
//     });
//   }
  
//   const applyDiscountBtn = document.querySelector(".applyDiscount");
//   console.log("applyDiscountBtn",applyDiscountBtn);
//   if(applyDiscountBtn){
//     applyDiscountBtn.addEventListener('click',function(){
//       const discountWrapper = this.closest(".discount-component");
//       const discountCode = discountWrapper.querySelector("input").value;
//       if(discountCode){
//         document.querySelector(".discount-component .coupen-error").classList.add("hidden");
//         document.querySelector(".discount-component .coupen-error").textContent = '';
//         console.log("discountCode",discountCode);
//         discountInCart(discountCode);
//       }else{
//         document.querySelector(".discount-component .coupen-error").classList.remove("hidden");
//         document.querySelector(".discount-component .coupen-error").textContent = 'Coupon does not exist!';
//       }
      
//     });
//   }

//   const coupenButtons = popup.querySelectorAll(".apply-button");
//   if(coupenButtons.length){
//     coupenButtons.forEach((couponBtn)=>{
//       couponBtn.addEventListener('click',function(){
//         const discountCode = couponBtn.closest(".coupon-row").getAttribute("data-couponcode");
//         discountInCart(discountCode);
//         popup.classList.remove('active');
//         overlay.classList.remove('active');
//       })
//     })
//   }
//   const removeBtn = document.querySelector('.applied-coupon-wrapper .remove-btn');
//   if (removeBtn) {
//     let sections = ['cart-drawer', 'cart-icon-bubble'];
//     removeBtn.addEventListener('click', function () {
//       fetch("/cart/update.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Accept": "application/json"
//         },
//         body: JSON.stringify({
//             "discount":'',
//               sections: sections
//         })
//       })
//       .then(res => res.json())
//       .then((response) => {
//         console.log("response",response);
//          const appliedCoupon = document.querySelector(".applied-coupon-wrapper");
//         appliedCoupon.classList.add('hidden');
  
//         const cartbtn = document.querySelector('#cart-icon-bubble');
//         const cartDrawer = document.querySelector('cart-drawer');
        
//         cartDrawer.classList.remove('is-empty');          
//         cartDrawer.renderContents(response);
//         cartbtn.dispatchEvent(new Event("click", { bubbles: true }));
//       });
//     });
//   }
// }


function cartUpsell(){
  // console.log("cart upsell items updated....");
  document.querySelectorAll(".cart-upsell-wrapper .crossell-item-wrapper").forEach(wrapper => {
    const variantList = wrapper.querySelector(".variant_list");
    if (!variantList) return;

    const variants = JSON.parse(variantList.dataset.variants || "[]");
    const priceWrapper = wrapper.querySelector(".price_wrapper");
    const optionGroups = wrapper.querySelectorAll(".option_group");
    const selectedOptions = {};

    // Auto-select first available option per group
    optionGroups.forEach(group => {
      const optionIndex = group.dataset.optionIndex;
      const firstOption = group.querySelector(".option_value");
      if (firstOption) {
        selectedOptions[optionIndex] = firstOption.dataset.value;
        firstOption.classList.add("selected");
        const firstValue = firstOption.dataset.value;
        group.setAttribute("data-selectedVal",firstValue);
      }
    });
    optionGroups.forEach(group => {
      group.addEventListener('click', function (event) {
        console.log("clicked...");
        if (!event.target.classList.contains('option_value')) {
          this.querySelector(".option_values").classList.add('active');
          console.log("class added");
        }
      });
    });

    // Option click handler
    wrapper.querySelectorAll(".option_value").forEach(option => {
      option.addEventListener("click", function () {
          handleOptionSelection(this);
      });
    });


    function handleOptionSelection(optionElement) {
      const index = optionElement.dataset.optionIndex;
      const value = optionElement.dataset.value;
      optionElement.closest(".option_group")?.setAttribute("data-selectedVal", value);
    
      if (index === "1") {
        const selectedOption1 = value;
    
        const matchedVariants = variants.filter(v => v.option1 === selectedOption1);
        const validOption2Values = [...new Set(matchedVariants.map(v => v.option2))];
        const validOption3Values = [...new Set(matchedVariants.map(v => v.option3))];
    
        const option2Group = wrapper.querySelector('[data-option-index="2"]');
        if (option2Group) {
          option2Group.querySelectorAll('.option_value').forEach(opt => {
            const val = opt.dataset.value;
            if (validOption2Values.includes(val)) {
              opt.classList.remove('hidden');
            } else {
              opt.classList.add('hidden');
              opt.classList.remove('selected');
            }
          });
        }
    
        const option3Group = wrapper.querySelector('[data-option-index="3"]');
        if (option3Group) {
          option3Group.querySelectorAll('.option_value').forEach(opt => {
            const val = opt.dataset.value;
            if (validOption3Values.includes(val)) {
              opt.classList.remove('hidden');
            } else {
              opt.classList.add('hidden');
              opt.classList.remove('selected');
            }
          });
        }
    
        ["2", "3"].forEach(optIndex => {
          const group = wrapper.querySelector(`[data-option-index="${optIndex}"]`);
          if (group) {
            const optionValues = Array.from(group.querySelectorAll(".option_value"));
            const visibleOptions = optionValues.filter(el => !el.classList.contains("hidden"));
    
            group.setAttribute("data-options_count", visibleOptions.length);
    
            const selectedVal = visibleOptions[0]?.dataset.value;
            if (selectedVal) {
              optionValues.forEach(el => el.classList.remove("selected"));
              visibleOptions[0].classList.add("selected");
              group.setAttribute("data-selectedval", selectedVal);
              selectedOptions[optIndex] = selectedVal;
            }
          }
        });
      }
    
      const siblings = optionElement.closest(".option_values").querySelectorAll(".option_value");
      siblings.forEach(el => el.classList.remove("selected"));
      optionElement.classList.add("selected");
    
      optionElement.closest(".option_values").classList.remove('active');
      console.log("class removed");
      selectedOptions[index] = value;
    
      const matchedVariant = variants.find(v => {
        return Object.keys(selectedOptions).every(i => v["option" + i] === selectedOptions[i]);
      });
    
      if (matchedVariant) {
        wrapper.querySelector("[crossell-addon-id]")?.setAttribute("crossell-addon-id", matchedVariant.id);
        wrapper.querySelector(".add-to-cart")?.setAttribute("data-crossellid", matchedVariant.id);
        wrapper.querySelector(".add-to-cart")?.setAttribute("data-crossell", matchedVariant);
        if (matchedVariant.featured_image?.src) {
          wrapper.querySelector("img").src = matchedVariant.featured_image.src;
        }
    
        const compareAt = matchedVariant.compare_at_price;
        const price = matchedVariant.price;
        const formattedComateAt = Shopify.formatMoney(compareAt, Shopify.money_format).replace(/\.00$/, "");
        const formattedPrice = Shopify.formatMoney(price, Shopify.money_format).replace(/\.00$/, "");
        let html = '';
    
        if (compareAt && compareAt > price) {
          const discount = compareAt - price;
          const percentage = Math.round((discount * 100) / compareAt);
          html += `<span class="comapre_price">+ ${formattedComateAt}</span>`;
          html += `<span class="sale_price">+ ${formattedPrice}</span>`;
          html += `<span class="discount_percentage">(${percentage}% OFF)</span>`;
        } else {
          if (compareAt) {
            html += `<span class="comapre_price">+ ${formattedComateAt}</span>`;
          }
          html += `<span class="sale_price">+ ${formattedPrice}</span>`;
        }
    
        if (priceWrapper) {
          priceWrapper.innerHTML = html;
        }
      }
    }
    
    const initiallySelectedOption = wrapper.querySelector('.option_value.selected');
    if (initiallySelectedOption) {
      handleOptionSelection(initiallySelectedOption);
    }
  });
  document.querySelectorAll(".cart-upsell-wrapper .crossell-item-wrapper .add-to-cart").forEach(button => {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-crossellid");
      if (!variantId) {
        console.warn("No variant selected to add to cart.");
        return;
      }
     let sections = ['cart-drawer', 'cart-icon-bubble'];
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sections
        })
      })
      .then((res) => res.json())
      .then((response) => {         
        window.Shopify?.publish?.("cartUpdate", { source: "upsell" });
        const cartpage = document.body.classList.contains("template-cart");
        console.log("cartpage",cartpage);
        if(!cartpage){
          const cartbtn = document.querySelector('.header-cart-icon');
          const cartDrawer = document.querySelector('cart-drawer');
          
          cartDrawer.classList.remove('is-empty');          
          cartDrawer.renderContents(response);
          cartbtn.dispatchEvent(new Event("click", { bubbles: true }));
        }else{
          window.location.href ='/cart';
        }

         dataLayer.push({
        'event': "gtm_event_add_to_cart",
        'ecommerce': {
            'currency': "INR",
            'value': parseFloat(response.final_price.toFixed(2)),            
            'items': [
                {
                    'item_id': response.sku,
                    'item_name': response.product_title,
                    'discount': response.original_price - response.discounted_price,
                    'index': 0,
                    'item_brand': "SleepyCat",
                    'item_category': response.product_type,
                    'price': parseFloat(response.original_price.toFixed(2)),
                    'product-variationId': response.variant_id,
                    'variant': response.variant_title,
                    'quantity': response.quantity,
                    'deal-price': parseFloat(response.discounted_price.toFixed(2)),
                    'product-category': response.product_type,
                    'product-size': response.options_with_values.find(item => item.name === "DIMENSION")?.value,
                    'product-color':  response.options_with_values.find(item => item.name === 'COLOR')?.value,
                    // 'product-pack': pr_set,
                    'page-path': response.url

                }
            ]
        }
        });
      })
      .catch(error => {
        console.error("Error adding to cart:", error);
      });
    });
  });
}
// function cartUpsell() {
//   document.querySelectorAll("cart-drawer-items .crossell-item-wrapper").forEach(wrapper => {
//     const variantList = wrapper.querySelector(".variant_list");
//     if (!variantList) return;

//     const variants = JSON.parse(variantList.dataset.variants || "[]");
//     const priceWrapper = wrapper.querySelector(".price_wrapper");
//     const optionGroups = wrapper.querySelectorAll(".option_group");
//     const selectedOptions = {};

//     // Auto-select first available option per group
//     optionGroups.forEach(group => {
//       const optionIndex = group.dataset.optionIndex;
//       const firstOption = group.querySelector(".option_value");
//       if (firstOption) {
//         selectedOptions[optionIndex] = firstOption.dataset.value;
//         firstOption.classList.add("selected");
//         group.setAttribute("data-selectedVal", firstOption.dataset.value);
//       }
//     });

//     // Open options dropdown on group click (if not clicking on option)
//     optionGroups.forEach(group => {
//       group.addEventListener('click', function (event) {
//         if (!event.target.classList.contains('option_value')) {
//           this.querySelector(".option_values").classList.add('active');
//         }
//       });
//     });

//     // Handle option selection
//     wrapper.querySelectorAll(".option_value").forEach(option => {
//       option.addEventListener("click", function () {
//         const index = this.dataset.optionIndex;
//         const value = this.dataset.value;

//         // Set selected value
//         const optionGroup = this.closest(".option_group");
//         optionGroup?.setAttribute("data-selectedVal", value);

//         // Deselect siblings and select this one
//         const siblings = this.closest(".option_values").querySelectorAll(".option_value");
//         siblings.forEach(el => el.classList.remove("selected"));
//         this.classList.add("selected");

//         // Hide dropdown
//         this.closest(".option_values").classList.remove('active');
//         selectedOptions[index] = value;

//         // Find matching variant
//         const matchedVariant = variants.find(v => {
//           return Object.keys(selectedOptions).every(i => {
//             return v["option" + i] === selectedOptions[i];
//           });
//         });

//         if (matchedVariant) {
//           // Update variant ID
//           wrapper.querySelector("[crossell-addon-id]")?.setAttribute("crossell-addon-id", matchedVariant.id);
//           wrapper.querySelector(".add-to-cart")?.setAttribute("data-crossellid", matchedVariant.id);

//           // Update image
//           if (matchedVariant.featured_image?.src) {
//             wrapper.querySelector("img").src = matchedVariant.featured_image.src;
//           }

//           // Format price
//           const compareAt = matchedVariant.compare_at_price;
//           const price = matchedVariant.price;
//           const formattedCompareAt = Shopify.formatMoney(compareAt, Shopify.money_format).replace(/\.00$/, "");
//           const formattedPrice = Shopify.formatMoney(price, Shopify.money_format).replace(/\.00$/, "");

//           let html = '';

//           if (compareAt && compareAt > price) {
//             const discount = compareAt - price;
//             const percentage = Math.round((discount * 100) / compareAt);
//             html += `<span class="compare_price">+ ${formattedCompareAt}</span>`;
//             html += `<span class="sale_price">+ ${formattedPrice}</span>`;
//             html += `<span class="discount_percentage">(${percentage}% OFF)</span>`;
//           } else {
//             if (compareAt) {
//               html += `<span class="compare_price">+ ${formattedCompareAt}</span>`;
//             }
//             html += `<span class="sale_price">+ ${formattedPrice}</span>`;
//           }

//           if (priceWrapper) {
//             priceWrapper.innerHTML = html;
//           }
//         }
//       });
//     });
//   });

//   // Add to cart handler
//    document.querySelectorAll("cart-drawer-items .crossell-item-wrapper .add-to-cart").forEach(button => {
//     button.addEventListener("click", function () {
//       const variantId = this.getAttribute("data-crossellid");
  
//       if (!variantId) {
//         console.warn("No variant selected to add to cart.");
//         return;
//       }
//      let sections = ['cart-drawer', 'cart-icon-bubble'];
//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Accept": "application/json"
//         },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: 1,
//           sections: sections
//         })
//       })
//       .then((res) => res.json())
//       .then((response) => { 
//             const cartbtn = document.querySelector('#cart-icon-bubble');
//             const cartDrawer = document.querySelector('cart-drawer');
            
//             cartDrawer.classList.remove('is-empty');          
//             cartDrawer.renderContents(response);
//             cartbtn.dispatchEvent(new Event("click", { bubbles: true }));
//         })
//       .catch(error => {
//         console.error("Error adding to cart:", error);
//       });
//     });
//   });
// }


class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
    cartUpsell();
    applyDiscountCode();
    // CUSTOM CODE
      var cart_count = document.querySelector("cart-drawer-items").getAttribute("data-item-count");
      var stickybarCount = document.querySelector(".sticky-bar-wrap .cart_item_count");
      if(stickybarCount) stickybarCount.innerHTML = cart_count;

    // CUSTOM CODE
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.main-cart-contents',
      },
      // {
      //   id: 'cart-icon-bubble',
      //   section: 'cart-icon-bubble',
      //   selector: '.shopify-section',
      // },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
      cartUpsell();
      applyDiscountCode();
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
